module.exports = __webpack_public_path__ + "static/wired-c57f9469a66fd299d906bfbfa79e9acd.png";